import api from './api'

export interface CannedResponse {
  id: string
  tenantId: string
  shortcut: string
  title: string
  content: string
  category: string | null
  createdAt: string
  updatedAt: string
}

export interface CreateCannedResponseDto {
  shortcut: string
  title: string
  content: string
  category?: string
}

export interface UpdateCannedResponseDto {
  shortcut?: string
  title?: string
  content?: string
  category?: string
}

export const cannedResponsesApi = {
  list(category?: string): Promise<CannedResponse[]> {
    const params = category ? { category } : {}
    return api.get('/api/canned-responses', { params }).then(r => r.data.data)
  },

  create(dto: CreateCannedResponseDto): Promise<CannedResponse> {
    return api.post('/api/canned-responses', dto).then(r => r.data.data)
  },

  update(id: string, dto: UpdateCannedResponseDto): Promise<CannedResponse> {
    return api.put(`/api/canned-responses/${id}`, dto).then(r => r.data.data)
  },

  delete(id: string): Promise<void> {
    return api.delete(`/api/canned-responses/${id}`).then(() => undefined)
  },
}

export interface CannedVariables {
  nombre_cliente?: string
  nombre_tienda?: string
  numero_cliente?: string
  producto?: string
  precio?: string
  total?: string
  direccion_envio?: string
  metodos_pago?: string
  [key: string]: string | undefined
}

/**
 * Replace template variables in canned response content.
 * Supports single `{var}` and double `{{var}}` syntax for:
 * nombre_cliente, nombre_tienda, numero_cliente, producto, precio, total, direccion_envio, metodos_pago
 */
export function resolveCannedVars(
  content: string,
  vars: CannedVariables
): string {
  let resolved = content

  const keys: Array<keyof CannedVariables> = [
    'nombre_cliente',
    'nombre_tienda',
    'numero_cliente',
    'producto',
    'precio',
    'total',
    'direccion_envio',
    'metodos_pago',
  ]

  for (const key of keys) {
    const val = vars[key]
    if (val !== undefined && val !== null && val !== '') {
      const doubleRegex = new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g')
      const singleRegex = new RegExp(`\\{${key}\\}`, 'g')
      resolved = resolved.replace(doubleRegex, val).replace(singleRegex, val)
    }
  }

  return resolved
}
